<template>
  <v-avatar
    :size="squareSize"
    :tile="!rounded"
    :class="backgroundClass"
    :style="`${pointerCursor ? 'cursor: pointer;': ''}`"
    v-on="on"
    @click="$emit('click')"
  >
    <div
      v-if="showOverlay && validImage"
      :style="`height: ${overlayHeight}px`"
      class="avatar-overlay"
    >
      <v-icon
        color="white"
        :size="overlayHeight"
        class="overlay-icon"
      >
        $snMenuDotsHorizontalSolid
      </v-icon>
    </div>
    <img
      v-if="validImage"
      :src="validImage"
      alt=""
      @error="handleImageError"
    >
    <span
      v-else
      :class="initialClass"
      :style="`font-size: ${initialSize}px; color: ${fontColor}; font-weight: 700`"
    >
      <v-icon
        v-if="icon"
        :size="iconSize"
        :style="iconStyle"
      >{{ icon }}</v-icon>
      <span
        v-if="initials"
        :style="initialStyle"
      >{{ initials }}</span>
    </span>
  </v-avatar>
</template>

<script>

export default {
  name: 'SnAvatar',
  props: {
    initials: {
      type: String,
      default: '',
      required: false
    },
    initialSize: {
      type: String,
      default: '17',
      required: false
    },
    initialStyle: {
      type: String,
      required: false,
      default: ''
    },
    initialClass: {
      type: String,
      required: false,
      default: ''
    },
    image: {
      type: String,
      required: false,
      default: ''
    },
    showOverlay: {
      type: Boolean,
      required: false,
      default: false
    },
    pointerCursor: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      default: '',
      required: false
    },
    iconStyle: {
      type: String,
      required: false,
      default: ''
    },
    iconSize: {
      type: String,
      required: false,
      default: ''
    },
    squareSize: {
      type: String,
      default: '40',
      required: false
    },
    rounded: {
      type: Boolean,
      default: true,
      required: false
    },
    backgroundClass: {
      type: String,
      default: 'sn-background-brand-02',
      required: false,
      validator (color) {
        return ['sn-background-brand-01', 'sn-background-brand-02', 'sn-background-gray-03'].includes(color)
      }
    },
    on: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      imageError: false
    }
  },
  computed: {
    fontColor () {
      return this.$vuetify.theme?.themes?.light?.snBrand03 ?? '#0F5F5E'
    },
    overlayHeight () {
      return this.squareSize * 0.28125
    },
    validImage () {
      if (this.imageError) return ''
      return this.image
    }
  },
  methods: {
    handleImageError () {
      this.imageError = true
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-overlay {
  position: absolute;
  width: 100%;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 1;
}
.overlay-icon {
  vertical-align: top;
}
</style>
